import { AffiliateForgetPage } from './affiliate-forget.component';
import { connect } from 'react-redux';
import { affiliateForgotPassword } from "./../../api/affiliate/affiliateAction";

const mapDispatchToProps = {
    affiliateForgotPassword
};

const mapStateToProps = state => ({
    isSent: state.affiliatePage.isSent,
    isLoading: state.affiliatePage.isLoading,
});

export const AffiliateForgetContainer = connect(mapStateToProps, mapDispatchToProps)(AffiliateForgetPage);
